module.exports = __webpack_public_path__ + "img/faviconW.66fde7ed.svg";